import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OrderCreationTooltipService {

    public changeTooltip() {
        let obj = JSON.parse(localStorage.getItem('orderCreationTooltip'));

        if (obj) {
            obj.enabled = !obj.enabled;
        } else {
            obj = {
                enabled: true
            };
        }

        localStorage.setItem('orderCreationTooltip', JSON.stringify(obj));
    }

    public tooltipEnabled() {
        const obj = JSON.parse(localStorage.getItem('orderCreationTooltip'));
        return obj ? obj.enabled : false;
    }

}
